import './product-list-section.scss';

(() => {
  const productListElement = document.querySelector('.ProductListSection');

  if (!productListElement) return;

  const previousSectionElement = productListElement.closest('.shopify-section').previousSibling;

  let eventFired = false;

  window.addEventListener('DOMContentLoaded', () => {
    window.addEventListener('scroll', () => {
      if (eventFired) return;

      if (previousSectionElement.getBoundingClientRect().bottom <= window.innerHeight) {
        window.CellExperiments.trigger('recommendations-about-to-enter');

        eventFired = true;
      }
    });
  });
})();
